/*
* Created on Jan 11, 2021
* @author: Adam Cheng <adamcheng@qnap.com>
*/

import React, {useEffect, useState} from 'react';
import welcome_illu_svg from '../../static/img/organization/welcome-illustration.svg'
import {useTranslation} from "react-i18next";
import {useRegion} from "../../context/RegionContext";

const MainWelcomeComponent = ({doRefresh}) => {
    const {t} = useTranslation();
    const {url} = useRegion();

    const goUserProfile = () => {
        window.open(`${url.get_acc_url()}/profile`, '_blank');
    }
    return (
        <div className="content content-page">
            <article className="welcome-screen">
                <div className="welcome-title">{t('@Before You Start@')}</div>
                <div className="welcome-desc">{t('@In order to begin using Organization Center, you will have to provide your email address within your QID account. People in the organization can reach you through email.@')}</div>
                <div className="welcome-illustration"><img src={welcome_illu_svg} /></div>
                <button type="button" className="q-btn q-btn-primary q-btn-large" onClick={goUserProfile}>{t('@Add Email@')}</button>
            </article>
        </div>
    );
};

export default MainWelcomeComponent;